export default {
  memberCommand: {
    "services": "Servicios",
    "diagnostics": "Diagnóstico para desarrolladores",
    "placeholder": "Busca una página o acción…",
    "club": "TU CLUB",
    "quick": "ACCIONES RÁPIDAS",
    "current": "Actual",
    "navigate": "Navegar",
    "open": "Abrir",
    "close": "Cerrar",
    "empty": "No hay páginas ni acciones que coincidan. Prueba otra búsqueda.",
    "clear": "Borrar búsqueda",
    "label": "Navegación de socios",
    "results": "{count} resultados disponibles",
    "bookings": "Mis reservas",
    "account": "Mi cuenta",
    "other": "Portal de socios",
    "dashboard": "Tu club de un vistazo",
    "book-facilities": "Golf, deportes de raqueta, restauración y más",
    "activities": "Descubre cómo disfrutar de tu club",
    "academy": "Campamentos, programas y talleres",
    "events": "Qué pasa en tu club",
    "reciprocal-clubs": "Explora tu red de clubes recíprocos",
    "accommodations": "Encuentra y reserva tu próxima estancia",
    "manage": "Gestiona tus actividades",
    "voting": "Consulta las mociones del club y vota",
    "dashboardKeywords": "inicio resumen",
    "book-facilitiesKeywords": "reservas deportes restaurante pistas",
    "activitiesKeywords": "clubes aficiones",
    "academyKeywords": "formación cursos clases",
    "eventsKeywords": "calendario entradas",
    "reciprocal-clubsKeywords": "colaboradores viajes acceso",
    "accommodationsKeywords": "hotel habitaciones estancias",
    "manageKeywords": "administración actividades",
    "votingKeywords": "mociones votos"
},
  member_all_handicaps: "Todos los hándicaps",
  member_handicap_or_better: "Hándicap {value} o mejor",
  member_handicap_or_worse: "Hándicap {value} o peor",

  member_leave: "Salir",
  member_unable_to_leave_this_open_group_right_now: "No se puede salir de este grupo abierto en este momento.",
  member_leave_group_confirm: "¿Salir de este grupo abierto?",
  member_hosts_manage_booking: "Gestiona tu reserva desde Próximas reservas.",
  member_loading_open_groups: "Cargando grupos abiertos…",
  member_open_groups: "Grupos abiertos",
  member_open_group_help: "Invita a otros socios a ocupar las plazas que elijas. La reserva es privada salvo que selecciones Grupo abierto.",
  member_level_not_provided: "Nivel no indicado",
  member_level_metric: "Nivel",
  member_handicap_metric: "Hándicap",
  member_all_levels: "Todos los niveles",
  member_level_preferences: "Intervalo de nivel preferido",
  member_level_preferences_help: "Opcional · escala del perfil de 1 a 5. Deja ambos campos vacíos para todos los niveles. Es una preferencia.",
  member_minimum_level: "Nivel mínimo",
  member_maximum_level: "Nivel máximo",
  member_open_groups_load_failed: "No se pudieron cargar los grupos abiertos.",
  member_open_group_details_failed: "No se pudieron cargar los detalles del grupo.",

  member_events_retry: "Volver a intentar",
  "member_events_heading": "Eventos",
  "member_event_count_one": "{count} evento",
  "member_event_count_other": "{count} eventos",
  "at_risk": "En riesgo",
  "super_engaged": "Muy participativos",
  "proactive_exposure_recovery_opportunities": "Riesgos y oportunidades de recuperación",
  "outstanding": "Pendiente",
  "cancellations": "Cancelaciones",
  "disengagement": "Desvinculación",
  "membership_spend_ytd": "Gasto de socios · Acumulado anual",
  "total_members": "Total de socios",
  "new_members": "Nuevos socios",
  "this_month": "Este mes",
  "amount_due": "Importe pendiente",
  "member_accounts": "Cuentas de socios",
  "find_a_member": "Buscar un socio",
  "search_members": "Buscar socios",
  "hidden_patterns_across_your_club": "Patrones ocultos en tu club",
  "no_current_intelligence_items": "No hay análisis actuales.",
  "no_upcoming_birthdays": "No hay cumpleaños próximos",
  "nothing_in_the_current_period": "Ninguno en el periodo actual",
  "club_conditions_and_forecast": "Condiciones y previsión del club",
  "view_current_conditions": "Ver condiciones actuales",
  "open_the_live_club_forecast": "Abrir la previsión del club en directo",
  "unable_to_load_this_dashboard_data_right_now": "No se pueden cargar los datos del panel en este momento.",
  "loading_exposure_detail": "Cargando detalles de exposición…",
  "outstanding_balances": "Saldos pendientes",
  "cancellations_refunds": "Cancelaciones y reembolsos",
  "disengagement_exposure": "Exposición por desvinculación",
  "total_exposure": "Exposición total",
  "record": "Registro",
  "no_records_in_this_category": "No hay registros en esta categoría.",
  "loading_metrics": "Cargando indicadores…",
  "unable_to_load_leadership_metrics": "No se pueden cargar los indicadores de dirección.",
  "executive_snapshot_year_to_date": "Resumen ejecutivo · Acumulado anual",
  "membership_spend": "Gasto de socios",
  "net_movement_this_month": "Variación neta de este mes",
  "member_account_exposure": "Exposición de cuentas de socios",
  "membership_health": "Estado de la comunidad de socios",
  "revenue_exposure_composition": "Composición de la exposición de ingresos",
  "needs_attention": "Requiere atención",
  "outstanding_member_account_balances_require_review": "Los saldos pendientes de cuentas de socios requieren revisión.",
  "loading_intelligence": "Cargando análisis…",
  "dashboard_details": "Detalles del panel",
  "favourites": "Favoritos",
  "new_chat": "Nuevo chat",
  "collapse_panel": "Contraer panel",
  "show_history": "Mostrar historial",
  "loading_conversation": "Cargando conversación…",
  "conversation_could_not_be_restored": "No se ha podido recuperar la conversación",
  "retry_loading": "Reintentar carga",
  "how_can_i_help_you_manage_the_club_today": "¿Cómo puedo ayudarte a gestionar el club hoy?",
  "external_sources": "Fuentes externas",
  "sources": "Fuentes",
  "prepare_again": "Preparar de nuevo",
  "sms_option": "Opción de SMS",
  "no_message_preview_available": "No hay vista previa del mensaje.",
  "sent": "Enviado",
  "member_option": "Opción de socio",
  "select": "Seleccionar",
  "review_proposed_action": "Revisar acción propuesta",
  "review_draft": "Revisar borrador",
  "review_action": "Revisar acción",
  "staff_member": "Empleado",
  "email_draft": "Borrador de correo",
  "select_one_of_your_mailboxes": "Selecciona uno de tus buzones",
  "connect_your_mailbox_to_prepare_mailbox_backed_drafts_later": "Conecta tu buzón para preparar borradores más adelante",
  "recipients": "Destinatarios",
  "no_recipients_selected_editable_unsent_draft": "Sin destinatarios · borrador editable sin enviar",
  "recipient_contact_details_need_attention_this_draft_remains_saved_and_unsent": "Revisa los datos de contacto de los destinatarios. El borrador sigue guardado y sin enviar.",
  "recipients_individual_emails": "destinatarios · correos individuales",
  "missing_email": "sin correo",
  "subject": "Asunto",
  "email_subject": "Asunto del correo",
  "email_cc": "CC del correo",
  "email_bcc": "CCO del correo",
  "sender_mailbox": "Buzón del remitente",
  "server_selected_mailbox": "Buzón seleccionado por el servidor",
  "email_body": "Cuerpo del correo",
  "preview_personalised_email": "Vista previa del correo personalizado",
  "first_name_is_personalised_for_each_recipient": "El nombre se personaliza para cada destinatario.",
  "preview_recipient": "Destinatario de la vista previa",
  "previewing_as": "Vista previa como",
  "recipient": "destinatario",
  "your_saved_signature": "Tu firma guardada",
  "connect_mailbox": "Conectar buzón",
  "discard": "Descartar",
  "reload_draft": "Recargar borrador",
  "action_failed": "Acción fallida",
  "an_unknown_error_occurred": "Se ha producido un error desconocido.",
  "golf_outing_created": "¡Salida de golf creada!",
  "view_in_events": "Ver en Eventos",
  "view_tee_sheet": "Ver hoja de salidas",
  "action_successful": "Acción completada",
  "stopping": "Deteniendo…",
  "preparing_your_answer": "Preparando tu respuesta.",
  "confirm_send": "Confirmar envío",
  "target": "Destino:",
  "confirming": "Confirmando…",
  "privana_assist_is_working": "Privana Assist está trabajando…",
  "answer_now_becomes_available_after_verified_work_completes": "Responder ahora estará disponible al finalizar el trabajo verificado.",
  "answer_now": "Responder ahora",
  "unable_to_continue": "No se puede continuar",
  "completed_evidence_and_outputs_were_retained": "Se han conservado las pruebas y los resultados completados.",
  "completed_verified_work_was_retained_you_can_retry_when_the_reported_constraint_is_resolved": "Se ha conservado el trabajo verificado completado. Puedes reintentar cuando se resuelva la limitación indicada.",
  "jump_to_latest": "Ir al último mensaje",
  "retry_loading_this_conversation_before_sending": "Reintenta cargar esta conversación antes de enviar.",
  "finish_cancel_or_answer_the_current_request_before_starting_another": "Finaliza, cancela o responde a la solicitud actual antes de iniciar otra.",
  "ask_privana_e_g_add_a_new_member_named_john_smith": "Pregunta a Privana… (p. ej., «añade un nuevo socio llamado Juan García»)",
  "send_message": "Enviar mensaje",
  "conversation_loading_failed_retry_is_required_before_you_can_send": "Error al cargar la conversación. Reintenta antes de enviar.",
  "explore": "Explorar",
  "shift_enter_for_newline": "Mayús+Intro para una nueva línea",
  "edit_sms_option": "Editar SMS (opción",
  "upcomingOne": "{count} cumpleaños próximo",
  "upcomingMany": "{count} cumpleaños próximos",
  "inDaysOne": "Dentro de {count} día",
  "inDaysMany": "Dentro de {count} días",
  "atRiskOne": "{count} socio está clasificado en riesgo.",
  "atRiskMany": "{count} socios están clasificados en riesgo.",
  "confidence": "Confianza",
  "confidenceHigh": "Alta",
  "confidenceMedium": "Media",
  "confidenceLow": "Baja",
  "confidenceCurrent": "Actual",
  "nextStep": "Siguiente paso: {action}",
  "highLow": "Máx.: {high}° Mín.: {low}°",
  "precipitation": "Probabilidad de precipitación",
  "keypadKey": "Marcar {key}",
  "starKey": "asterisco",
  "hashKey": "almohadilla",
  "deleteDigit": "Borrar último dígito",
  "favouriteChat": "Marcar conversación como favorita",
  "unfavouriteChat": "Quitar conversación de favoritos",
  "deleteChat": "Eliminar conversación",
  "emptyHistory": "Todavía no hay conversaciones.",
  "emptyFavourites": "Todavía no hay conversaciones favoritas.",
  "patterns": {
    "department_exposure_concentration": {
      "headline": "El riesgo de ingresos se concentra en {department}",
      "evidence": "El {percent} % de la exposición actual está vinculado a {department}.",
      "implication": "Una variación en este departamento podría afectar rápidamente a la liquidez. Asigna a alguien para revisar esta semana las principales cuentas por cobrar y causas de cancelación en {department}.",
      "actionLabel": "Revisar la dependencia de {department}"
    },
    "outstanding_balance_department_concentration": {
      "headline": "La mayoría de los saldos pendientes están vinculados a {department}",
      "evidence": "El {percent} % de los saldos abiertos procede de {department}.",
      "implication": "El mayor impacto en los cobros probablemente esté en {department}; dar prioridad a esta cola debería acelerar la recuperación de efectivo.",
      "actionLabel": "Priorizar cobros de {department}"
    },
    "cancellation_day_of_week_spike": {
      "headline": "Las cancelaciones se concentran los {day}",
      "evidence": "El {percent} % de las cancelaciones de los últimos 90 días ocurrió en {day} (aproximadamente {ratio} veces otros días de la semana).",
      "implication": "Esto suele indicar dificultades de servicio o de horarios en un día concreto. Revisa el personal, los plazos de reserva y los motivos de cancelación de los {day}.",
      "actionLabel": "Auditar el proceso de reservas de los {day}"
    },
    "disengagement_department_overlap": {
      "headline": "Los socios en riesgo se concentran de forma desproporcionada en {department}",
      "evidence": "El {percent} % de los socios en riesgo por baja participación está vinculado a patrones de actividad de {department}.",
      "implication": "Una campaña dirigida para recuperar la participación en {department} podría reducir la pérdida futura de ingresos.",
      "actionLabel": "Lanzar campaña de participación en {department}"
    },
    "revenue_vs_activity_divergence": {
      "headline": "Los ingresos crecen más rápido que la actividad de socios",
      "evidence": "Los ingresos aumentaron un {revenueChange} % en 30 días, mientras que la actividad de transacciones varió un {activityChange} %.",
      "implication": "El crecimiento de ingresos puede deberse a los precios o a la composición de ventas en lugar de una mayor participación. Revisa qué departamentos y grupos de socios impulsan el aumento.",
      "actionLabel": "Validar la calidad del crecimiento por segmento"
    },
    "receivables_cluster_by_department": {
      "headline": "Las cuentas por cobrar más antiguas se concentran en {department}",
      "evidence": "El {percent} % de los saldos de más de 60 días está en {department}.",
      "implication": "El retraso en los cobros parece concentrado. Una estrategia dirigida a la antigüedad de saldos en {department} debería mejorar la recuperación.",
      "actionLabel": "Priorizar contactos por saldos de más de 60 días en {department}"
    },
    "rising_risk_falling_usage": {
      "headline": "El riesgo de socios aumenta mientras la exposición sigue concentrada",
      "evidence": "Los socios en riesgo aumentaron en {delta}, mientras que {department} sigue representando el {percent} % de la exposición.",
      "implication": "Si el riesgo de socios sigue aumentando, esta concentración puede agravarse rápidamente. Prioriza el contacto con socios con saldos elevados en el departamento expuesto.",
      "actionLabel": "Contactar primero con socios en riesgo con saldos elevados"
    }
  },
  "departments": {
    "membership": "Socios",
    "golf": "Golf",
    "racquet": "Raqueta",
    "spa": "Spa",
    "rooms": "Habitaciones",
    "events": "Eventos",
    "fitness": "Fitness",
    "other": "Otros"
  },
  "this_insight_could_not_be_displayed": "No se ha podido mostrar este análisis.",
  "no_chart_data_is_available": "No hay datos disponibles para el gráfico.",
  "series": "Series:",
  "categories": ". Categorías:",
  "data_is_unavailable": "no hay datos disponibles",
  "comparison_data_is_available_for": "Hay datos comparativos para",
  "of_the": "de los",
  "displayed_periods_gaps_are_unavailable": "periodos mostrados; los intervalos vacíos no están disponibles.",
  "partial_data_available_from": "Datos parciales: disponibles desde",
  "categories_were_limited_to_the_most_significant_results": "Las categorías se han limitado a los resultados más significativos.",
  "view_data": "Ver datos",
  "download_csv": "Descargar CSV",
  "open_in_module": "Abrir en módulo",
  "exact_data_used_for": "Datos exactos utilizados para",
  "current_period_is_incomplete_its_value_is_provisional": "* El periodo actual está incompleto; su valor es provisional.",
  "about_this_chart": "Acerca de este gráfico",
  "complete_through": "Completos hasta",
  "generated": ") · generado",
  "latest_observed_record": "Último registro observado:",
  "compared_with": "Comparado con",
  "the_current_period_is_incomplete": "El periodo actual está incompleto.",
  "club_inventory": "Inventario del club",
  "show": "Mostrar",
  "more": "más",
  "fytd": "Acumulado del ejercicio",
  "joined": "Alta",
  "renewal": "Renovación",
  "account": "Cuenta",
  "contact": "Contacto",
  "recent_activity": "Actividad reciente",
  "no_recent_activity_recorded": "No hay actividad reciente registrada.",
  "showing": "Mostrando",
  "of_at_least": "de al menos",
  "rows": "filas.",
  "coverage": "Cobertura",
  "comparison": "Comparación",
  "revision": "· revisión",
  "key_findings": "Hallazgos principales",
  "supporting_chart_is_unavailable_or_no_longer_accessible": "El gráfico de apoyo no está disponible o ya no es accesible.",
  "risks_and_exceptions": "Riesgos y excepciones",
  "recommendations": "Recomendaciones",
  "intended_outcome": "Resultado previsto:",
  "next_actions": "Próximas acciones",
  "coverage_limitations": "Cobertura y limitaciones",
  "about_this": "Acerca de este",
  "data_used": "Datos utilizados",
  "why": "¿Por qué?",
  "report_revision": "Revisión del informe",
  "calculation_date": "Fecha del cálculo",
  "trading_picture": "Panorama comercial",
  "vs": "frente a",
  "revenue_by_department": "Ingresos por departamento",
  "variance": "· variación",
  "revenue_trend": "Evolución de ingresos",
  "collections_by_method": "Cobros por método",
  "privana_observations": "Observaciones de Privana",
  "live_operational_weather": "Tiempo operativo en directo",
  "live_club_forecast_updated": "Previsión del club en directo · Actualizada",
  "this_file_is_no_longer_stored_generated_files_are_retained_for_7_days": "Este archivo ya no está almacenado. Los archivos generados se conservan durante 7 días.",
  "available_until": "Disponible hasta",
  "loading_preview": "Cargando vista previa…",
  "view_member": "Ver socio",
  "create_golf_outing": "Crear salida de golf",
  "event_title": "Título del evento",
  "description": "Descripción",
  "max_capacity": "Capacidad máxima",
  "start_time": "Hora de inicio",
  "end_time": "Hora de fin",
  "location": "Ubicación",
  "weather_forecast": "Previsión del tiempo",
  "golf_scope": "Ámbito de golf",
  "booked_players": "Jugadores reservados",
  "tee_utilisation": "Ocupación de salidas",
  "occupied_slots": "Turnos ocupados",
  "available_slots": "Turnos disponibles",
  "forecast_date": "Fecha de previsión",
  "operational_risk": "Riesgo operativo",
  "current_snapshot": "Resumen actual",
  "previous_year": "Año anterior",
  "for_the_displayed_periods": " para los periodos mostrados",
  "creating": "Creando…",
  "untitled": "Sin título",
  "report": "Informe",
  "noMatches": "No hay resultados coincidentes",
  "unavailableData": "Esta información no está disponible en este momento.",
  "assistUnavailable": "Assist no está disponible temporalmente. Reintenta este mensaje.",
  "draftConflict": "No se ha podido actualizar el borrador. Recárgalo antes de volver a intentarlo.",
  "queued": "Solicitud aceptada.",
  "running": "Privana Assist está trabajando…",
  "finalising": "Terminando tu respuesta…",
  "cancelling": "Deteniendo…",
  "paused": "En pausa",
  "failed": "No se puede continuar",
  "openFile": "Abrir {name}",
  "downloadFile": "Descargar {name}",
  "termUnavailable": "No se ha podido consultar el periodo de afiliación en este momento.",
  "noRenewal": "No hay fecha de renovación registrada.",
  "noTerm": "No hay periodo de afiliación actual registrado.",
  "financeUnavailable": "No se ha podido consultar la información financiera en este momento.",
  "accountAvailable": "Estado de cuenta disponible.",
  "viewProfile": "Ver perfil del socio",
  "previewFailed": "Vista previa no disponible.",
  "downloadFailed": "Descarga no disponible.",
  "openFailed": "No se puede abrir.",
  "restricted": "No tienes permiso para ver esta información.",
  "references": {
    "outstanding": "Saldo pendiente",
    "cancelled": "Reserva cancelada o reembolso",
    "engagement": "Tendencia de baja participación"
  },
  "available": "Disponible",
  "partial": "Parcial",
  "unavailable": "No disponible",
  "high": "Alta",
  "medium": "Media",
  "low": "Baja",
  "unknown": "Desconocido",
  "result": "Resultado",
  "weatherLow": "Buenas condiciones para operaciones al aire libre",
  "weatherElevated": "Cierto riesgo de interrupciones",
  "weatherHigh": "Alto riesgo de interrupciones",
  "gusts": "rachas",
  "low_source_coverage": "algunas fuentes tienen cobertura limitada",
  "insufficient_points": "solo hay datos históricos limitados",
  "partially_available": "no todas las áreas solicitadas aportaron pruebas utilizables",
  "no_comparison_period": "la comparación con el periodo anterior no está disponible",
  "provisional_period": "el periodo actual está incompleto",
  "source_coverage": "la cobertura de las fuentes es limitada",
  "coverageLimited": "Los datos de {names} no estaban disponibles para este periodo, por lo que la evaluación operativa del informe es limitada.",
  "coverageHelp": "Este informe incluye las pruebas disponibles y señala las limitaciones a continuación.",
  "revenueRecords": "Registros de ingresos",
  "memberRecords": "Registros de socios",
  "receivableRecords": "Registros de cuentas por cobrar",
  "eventRecords": "Registros de eventos",
  "elementRecords": "Registros de Element",
  "managementRecords": "Registros de gestión disponibles",
  "and": " y ",
  "tableLabel": "Tabla {title}",
  "becauseRecordsBegin": " porque los registros comienzan el {date}",
  "completed": "Completo",
  "unspecified": "Sin especificar",
  "none": "Ninguno",
  "confidenceBadge": "Confianza {value}",
  "analyticalDescription": "Mostrando {series} por {dimension}.",
  "analyticalView": "Vista analítica.",
  "governedResult": "Resultado analítico controlado",
  "supportedEvidence": "Respaldado por las pruebas disponibles.",
  "collapse": "Contraer",
  "briefing": "Resumen",
  "working": "Trabajando…",
  "originalReport": "Informe original",
  "revisionReport": "Revisión de un informe anterior",
  "extensionReady": "Extensión lista",
  "transferringTarget": "Transfiriendo a {target}…",
  "consultControls": "Controles de la llamada de consulta",
  "consultDialpad": "Teclado de consulta",
  "closeDialpad": "Cerrar teclado",
  "sendDtmf": "Enviar tono {digit}",
  "unmute": "Activar micrófono",
  "hangUp": "Colgar",
  "inProgress": "En curso",
  "consultation_active": "Consulta activa",
  "financeStatuses": {
    "draft": "Borrador",
    "submitted": "Presentado",
    "board_approved": "Aprobado por la junta",
    "approved": "Aprobado",
    "locked": "Bloqueado",
    "favourable": "Favorable",
    "adverse": "Desfavorable",
    "on_budget": "Según presupuesto",
    "consistent": "Coherente",
    "mismatch": "Diferencia",
    "reconciled": "Conciliado",
    "explained_difference": "Diferencia explicada",
    "unexplained_difference": "Diferencia sin explicar",
    "insufficient_evidence": "Pruebas insuficientes"
  },
  "destination_prepared": "Destino preparado",
  "destination_ringing": "Destino sonando",
  "consultation_failed": "Consulta fallida",
  "consultation_cancelling": "Cancelando consulta",
  "consultation_cancelled": "Consulta cancelada",
  "clubFallback": "Club",
  "atAGlance": "{club} de un vistazo",
  "cc": "CC",
  "bcc": "CCO",
  "proceed": "¿Cómo te gustaría continuar?",
  "selectMemberFailed": "No se ha podido seleccionar ese socio. Inténtalo de nuevo.",
  "reviewSms": "Revisa y confirma antes de que envíe este SMS.",
  "confirmationCancelled": "Confirmación cancelada. No se ha enviado ningún mensaje.",
  "verifyAction": "Assist no está disponible temporalmente. Verifica el estado de la acción antes de reintentar.",
  "discardedEdit": "Los borradores descartados no se pueden editar.",
  "saveDraftFailed": "No se ha podido guardar",
  "discardDraftFailed": "No se ha podido descartar",
  "forwardedMessage": "Mensaje reenviado",
  "smsFailed": "No se ha podido enviar el SMS.",
  "smsSimulation": "Solo simulación de SMS: no se ha enviado ningún mensaje real.",
  "smsSimulationLine": "Solo simulación ⚠️ No se ha enviado ningún SMS al socio.",
  "smsNotSent": "SMS no enviado ⚠️",
  "smsSuccess": "Mensaje enviado correctamente",
  "smsSent": "SMS enviado ✅",
  "golfOutingPlaceholder": "Salida de golf",
  "selectCourse": "Selecciona un campo…",
  "courseVenue": "Nombre del campo o recinto",
  "allGolfCourses": "Todos los campos de golf",
  "member_back_to_accommodations": "Volver a alojamientos",
  "member_your_booking": "tu reserva",
  "member_confirm_occupancy_settlement_method_and_submit_your_booking_request": "Confirma la ocupación y el método de pago y envía tu solicitud de reserva.",
  "member_booking_request_confirmed": "Solicitud de reserva confirmada",
  "member_your_accommodation_request_is_now_pending_confirmation_from_the_club_team": "Tu solicitud de alojamiento está pendiente de confirmación por el equipo del club.",
  "member_reservation_reference": "Referencia de reserva:",
  "member_photos_coming_soon": "Fotos próximamente",
  "member_previous_photo": "Foto anterior",
  "member_next_photo": "Foto siguiente",
  "member_room_plan": "Distribución de habitaciones",
  "member_adults": "adultos ·",
  "member_children": "niños",
  "member_anything_we_should_prepare": "¿Debemos preparar algo?",
  "member_special_requests_optional": "Peticiones especiales (opcional)",
  "member_late_arrival_adjoining_rooms_dietary_preferences_or_anything_else": "Llegada tardía, habitaciones contiguas, preferencias alimentarias u otras peticiones.",
  "member_review_confirm": "Revisar y confirmar",
  "member_nights": "Noches",
  "member_rooms_guests": "Habitaciones · Huéspedes",
  "member_rooms": "habitaciones ·",
  "member_nightly_rate_per_room": "Tarifa por noche (por habitación)",
  "member_add_to_member_account": "Cargar a la cuenta de socio",
  "member_pay_by_card_online": "Pagar con tarjeta en línea",
  "member_pay_on_arrival": "Pagar a la llegada",
  "member_this_room_type_does_not_yet_have_a_configured_rate_please_contact_the_club": "Este tipo de habitación aún no tiene una tarifa configurada. Contacta con el club.",
  "member_visual_coming_soon": "Imagen próximamente",
  "member_rooms_available": "habitaciones disponibles",
  "member__night": "/ noche",
  "member_stay_in": "Alójate con",
  "member_style": "estilo",
  "member_choose_your_dates_and_room_setup_to_see_currently_available_suites": "Elige las fechas y la distribución de habitaciones para ver las suites disponibles.",
  "member_check_in_check_out": "Llegada / Salida",
  "member_guests_rooms": "Huéspedes / Habitaciones",
  "member_add_rooms_as_needed": "Añade las habitaciones que necesites",
  "member_decrease_rooms": "Reducir habitaciones",
  "member_increase_rooms": "Añadir habitaciones",
  "member_adults_2": "Adultos",
  "member_children_2": "Niños",
  "member_check_availability": "Consultar disponibilidad",
  "member_step_2": "Paso 2",
  "member_available_room_types": "Tipos de habitación disponibles",
  "member_loading_suites_and_rooms": "Cargando suites y habitaciones…",
  "member_no_rooms_are_available_to_request_right_now": "No hay habitaciones disponibles para solicitar en este momento.",
  "member_accommodation_room_details": "Detalles del alojamiento",
  "member_close_room_details": "Cerrar detalles de la habitación",
  "member_total_estimate": "Total estimado",
  "member_continue_to_booking": "Continuar con la reserva",
  "member_discover_club_programming": "Descubre las actividades del club",
  "member_loading_activities": "Cargando actividades…",
  "member_no_activities_are_available_right_now": "No hay actividades disponibles en este momento.",
  "member_view_sessions": "Ver sesiones",
  "member_book_or_manage_your_reservation": "Haz o gestiona tu reserva.",
  "member_back_to_activities": "Volver a actividades",
  "member_loading_sessions": "Cargando sesiones…",
  "member_no_sessions_are_scheduled_yet": "Aún no hay sesiones programadas.",
  "member_dismiss_notification": "Descartar notificación",
  "member_players": "jugadores ·",
  "member_can_cancel": "Cancelación disponible",
  "member_total_cost": "Coste total",
  "member_no_players_listed": "No hay jugadores registrados",
  "member_no_add_ons": "Sin extras",
  "member_cancellation_policy_status": "Estado de la política de cancelación",
  "member_you_may_cancel_this_booking_online_under_the_club_s_cancellation_policy": "Puedes cancelar esta reserva en línea según la política de cancelación del club.",
  "member_cutoff": "Límite:",
  "member_hours_before_tee_time": "horas antes de la salida",
  "member_cancel_booking": "Cancelar reserva",
  "member_you_may_cancel_this_racquet_booking_through_member_portal_cancellation": "Puedes cancelar esta reserva de pista desde el portal de socios.",
  "member_you_may_cancel_this_spa_booking_through_member_portal_cancellation": "Puedes cancelar esta reserva de spa desde el portal de socios.",
  "member_fitness_booking": "Reserva de fitness",
  "member_you_may_cancel_this_fitness_booking_through_member_portal_cancellation": "Puedes cancelar esta reserva de fitness desde el portal de socios.",
  "member_full_stay_cost": "Coste total de la estancia",
  "member_you_may_cancel_this_hotel_rooms_booking_through_member_portal_cancellation": "Puedes cancelar esta reserva de alojamiento desde el portal de socios.",
  "member_need_to_adjust_this_booking_please_contact_the_club": "¿Necesitas modificar esta reserva? Contacta con el club.",
  "member_club_overview": "Resumen del club",
  "member_resolving_member_profile": "Cargando el perfil de socio",
  "member_welcome_to_your_private_sanctuary": "Te damos la bienvenida a tu refugio privado",
  "member_let_s_play": "¡A jugar!",
  "member_upcoming_bookings": "Próximas reservas",
  "member_your_next_experiences_at_the_club": "Tus próximas experiencias en el club",
  "member_check_back_here_soon_for_more_exciting_club_news": "¡Vuelve pronto para descubrir más noticias del club!",
  "member_loading_club_news": "Cargando noticias del club",
  "member_member_updates": "Novedades para socios",
  "member_preparing_pdf_viewer": "Preparando el visor PDF…",
  "member_mark_as_read": "Marcar como leído",
  "member_member_bookings": "Reservas de socio",
  "member_all_upcoming_experiences": "Todas las próximas experiencias",
  "member_upcoming": "próximas",
  "member_upcoming_bookings_carousel": "Carrusel de próximas reservas",
  "member_select_a_booking_to_view_details": "Selecciona una reserva para ver los detalles",
  "member_choose_a_booking_from_the_list_to_see_policy_information_players_add_ons_payment_details_and_available_actions": "Elige una reserva de la lista para ver la política, los jugadores, los extras, los detalles de pago y las acciones disponibles.",
  "member_close_cancellation_confirmation": "Cerrar confirmación de cancelación",
  "member_cancel_this_tee_time": "¿Cancelar esta salida?",
  "member_this_will_cancel_your_tee_time_and_update_your_member_account_this_cannot_be_undone_online": "Se cancelará tu salida y se actualizará tu cuenta de socio. No podrás deshacerlo en línea.",
  "member_keep_booking": "Mantener reserva",
  "member_cancel_tee_time": "Cancelar salida",
  "member_cancel_this_racquet_booking": "¿Cancelar esta reserva de pista?",
  "member_this_will_cancel_your_booking_and_apply_the_club_cancellation_policy": "Se cancelará tu reserva y se aplicará la política de cancelación del club.",
  "member_cancel_this_spa_booking": "¿Cancelar esta reserva de spa?",
  "member_cancel_this_fitness_booking": "¿Cancelar esta reserva de fitness?",
  "member_cancel_this_hotel_rooms_booking": "¿Cancelar esta reserva de alojamiento?",
  "member_this_will_cancel_your_stay_and_apply_the_club_cancellation_policy": "Se cancelará tu estancia y se aplicará la política de cancelación del club.",
  "member_explore_exclusive_events": "Descubre eventos exclusivos...",
  "member_search_titles_venues_or_occasion_type": "Buscar por título, lugar o tipo de evento",
  "member_event_timeframe": "Periodo de los eventos",
  "member_my_calendar": "Mi calendario",
  "member_confirmed_attendance": "Asistencia confirmada",
  "member_accessibility": "Accesibilidad",
  "member_remove_guest": "Eliminar invitado",
  "member_attendance_notes": "Notas de asistencia",
  "member_dietary_needs_accessibility_notes_or_concierge_requests": "Necesidades alimentarias, notas de accesibilidad o peticiones de conserjería",
  "member_book_facilities": "Reservar instalaciones",
  "member_choose_your_next_activity": "Elige tu próxima actividad",
  "member_facilities_could_not_be_refreshed": "No se han podido actualizar las instalaciones.",
  "member_loading_facilities": "Cargando instalaciones",
  "member_facilities_will_appear_here_when_your_club_enables_them": "Las instalaciones aparecerán aquí cuando tu club las active.",
  "member_available_times": "HORARIOS DISPONIBLES",
  "member_loading_availability": "Consultando disponibilidad…",
  "member_no_available_times_for_this_day": "No hay horarios disponibles para este día.",
  "member_loading_schedule": "Cargando programación…",
  "member_no_upcoming_fitness_classes_with_availability": "No hay próximas clases de fitness con plazas disponibles.",
  "member_sessions": "sesiones",
  "member_view_open_groups": "Ver grupos abiertos",
  "member_view_rates": "Ver tarifas",
  "member_no_available_tee_times_for_this_day": "No hay horarios de salida disponibles para este día.",
  "member_up_to": "Hasta",
  "member_players_2": "jugadores",
  "member_book_now": "Reservar ahora",
  "member_rates_are_not_available_yet_please_contact_the_pro_shop": "Las tarifas aún no están disponibles. Contacta con la tienda de golf.",
  "member_back_to_tee_times": "Volver a horarios de salida",
  "member_course_rates": "Tarifas del campo",
  "member_loading_course": "Cargando campo…",
  "member_select_rate_type": "Seleccionar tipo de tarifa",
  "member_member_rates": "Tarifas para socios",
  "member_guest_rates": "Tarifas para invitados",
  "member_pricing": "tarifas",
  "member__hole": " hoyos",
  "member_fetching_available_courses_for_your_club": "Consultando los campos disponibles de tu club.",
  "member_choose_your_course": "Elige tu campo",
  "member_select_a_course_to_view_available_tee_times": "Selecciona un campo para ver los horarios de salida disponibles.",
  "member_no_active_courses_are_available_for_booking_yet": "Aún no hay campos activos disponibles para reservar.",
  "member_court": "pista",
  "member_private_booking": "Reserva privada",
  "member_open_match": "Partido abierto",
  "member_match_type": "Tipo de partido",
  "member_competitive": "Competitivo",
  "member_who_can_join": "Quién puede unirse",
  "member_host_approval": "Aprobación del organizador",
  "member_direct_join": "Inscripción directa",
  "member_optional_note": "Nota opcional",
  "member_anything_players_should_know": "¿Deben saber algo los jugadores?",
  "member_add_to_your_booking": "Añadir a tu reserva",
  "member_view_other_times": "Ver otros horarios",
  "member_close_player_sheet": "Cerrar selección de jugadores",
  "member_search_by_name": "Buscar por nombre",
  "member_searching_members": "Buscando socios",
  "member_sport_not_supported": "Deporte no disponible",
  "member_we_couldn_t_recognize_this_sport_please_return_to_facilities": "No se ha reconocido este deporte. Vuelve a instalaciones.",
  "member_back_to_courts": "Volver a pistas",
  "member_confirm_your_court": "Confirma tu pista",
  "member_book_a_court": "Reservar una pista",
  "member_create_open_match": "Crear partido abierto",
  "member_select_open_match_type": "Seleccionar tipo de partido abierto",
  "member_select_join_policy": "Seleccionar política de inscripción",
  "member_open_match_note": "Nota del partido abierto",
  "member_optional_details_for_players_joining": "Información opcional para los jugadores que se unan",
  "member_mobile_for_updates": "Móvil para recibir novedades",
  "member_email_for_confirmation": "Correo para la confirmación",
  "member__add_player": "+ Añadir jugador",
  "member_maximum_players_reached_for_this_court": "Se ha alcanzado el máximo de jugadores para esta pista.",
  "member_enhance_your_visit": "Mejora tu visita",
  "member_no_add_ons_available_for_this_sport": "No hay extras disponibles para este deporte.",
  "member_racquet_booking": "Reserva de pista",
  "member_estimated_total": "Total estimado",
  "member_calculated_from_live_pricing_policy": "Calculado según la política de precios vigente",
  "member_default_session": "Sesión predeterminada:",
  "member_member_rate_on_file": "Tarifa de socio registrada",
  "member_guest_rate_on_file": "Tarifa de invitado registrada",
  "member_left": "disponibles",
  "member_skill": "Nivel",
  "member_vacant_spot": "Plaza libre",
  "member_no_pending_join_requests_right_now": "No hay solicitudes de inscripción pendientes.",
  "member_pending_invites": "Invitaciones pendientes",
  "member_back_to_racquet_availability": "Volver a disponibilidad de pistas",
  "member_loading_match_details": "Cargando detalles del partido…",
  "member_back_to_facilities": "Volver a instalaciones",
  "member_no_courts_available_for": "No hay pistas disponibles para",
  "member_select_court_date": "Seleccionar fecha de pista",
  "member_open_matches": "Partidos abiertos",
  "member_loading_open_matches": "Cargando partidos abiertos…",
  "member_no_open_matches_available_for_this_date": "No hay partidos abiertos disponibles para esta fecha.",
  "member_choose_a_time": "Elige un horario",
  "member_no_available_start_times_for_this_day": "No hay horarios de inicio disponibles para este día.",
  "member_available_start_times": "Horarios de inicio disponibles",
  "member_choose_a_court": "Elige una pista",
  "member_no_courts_are_available_for_this_time": "No hay pistas disponibles para este horario.",
  "member_no_slots_available_for_this_day": "No hay horarios disponibles para este día.",
  "member_open_matches_to_join": "Partidos abiertos para unirse",
  "member_spots_left": "plazas disponibles",
  "member_your_match": "Tu partido",
  "member_view_requests": "Ver solicitudes",
  "member_payment_required": "Pago necesario",
  "member_due": "pendientes",
  "member_add_to_account": "Cargar a la cuenta",
  "member_pay_online": "Pagar en línea",
  "member_you_are_in_this_match": "Estás inscrito en este partido",
  "member_host_controls": "Controles del organizador",
  "member_manage_open_match": "Gestionar partido abierto",
  "member_manage_open_match_requests": "Gestionar solicitudes del partido abierto",
  "member_pay_online_for_open_match": "Pagar partido abierto en línea",
  "member_payment_summary": "Resumen de pago",
  "member_match_time_date": "Fecha y hora del partido",
  "member_cardholder_name": "Nombre del titular",
  "member_card_number": "Número de tarjeta",
  "member_expiry": "Caducidad",
  "member_mm_yy": "MM/AA",
  "member_billing_postcode_zip": "Código postal de facturación",
  "member_online_card_payments_are_not_enabled_yet": "Los pagos con tarjeta en línea aún no están habilitados.",
  "member_confirm_payment": "Confirmar pago",
  "member_members_portal": "PORTAL DE SOCIOS",
  "member_browse_partner_clubs_and_request_a_guest_pass_to_visit": "Explora los clubes asociados y solicita un pase de invitado para visitarlos.",
  "member_search_by_club_or_location": "Buscar por club o ubicación",
  "member_loading_reciprocal_clubs": "Cargando clubes recíprocos…",
  "member_no_partner_clubs_available_yet": "Aún no hay clubes asociados disponibles.",
  "member_amenities_coming_soon": "Servicios próximamente",
  "member_visit_website": "Visitar sitio web",
  "member_reciprocal_club": "Club recíproco",
  "member_amenities_coming_soon_2": "Servicios próximamente.",
  "member_visit_date": "Fecha de visita",
  "member_note_message_optional": "Nota o mensaje (opcional)",
  "member_let_us_know_anything_helpful_for_your_visit": "Indícanos cualquier información útil para tu visita.",
  "member_request_sent": "¡Solicitud enviada!",
  "member_your_guest_pass_request_has_been_submitted_we_ll_notify_you_once_it_s_approved": "Tu solicitud de pase de invitado se ha enviado. Te avisaremos cuando se apruebe.",
  "member_request_reference": "Referencia de solicitud:",
  "member_back_to_reciprocal_clubs": "Volver a clubes recíprocos",
  "member_back_to_services": "Volver a servicios",
  "member_choose_a_service": "Elige un servicio",
  "member_search_services": "Buscar servicios",
  "member_loading_services": "Cargando servicios…",
  "member_no_spa_services_available": "No hay servicios de spa disponibles.",
  "member_holes": "hoyos",
  "member_confirm_your_time": "Confirma tu horario",
  "member_please_select_holes_to_continue": "Selecciona los hoyos para continuar.",
  "member_open_group": "GRUPO ABIERTO",
  "member_open_group_toggle": "Activar grupo abierto",
  "member_open_group_2": "Grupo abierto",
  "member_open_groups_not_available_for_this_player_mix": "Los grupos abiertos no están disponibles para esta combinación de jugadores.",
  "member_looking_for": "Buscando",
  "member_open_group_size": "Tamaño del grupo abierto",
  "member_player": "jugador",
  "member_min_handicap_optional": "Hándicap mínimo (opcional)",
  "member_e_g_10_0": "p. ej., 10.0",
  "member_max_handicap_optional": "Hándicap máximo (opcional)",
  "member_e_g_24_0": "p. ej., 24.0",
  "member_note_for_guests_optional": "Nota para invitados (opcional)",
  "member_share_expectations_or_preferences": "Comparte expectativas o preferencias",
  "member_spots_available": "Plazas disponibles:",
  "member_enhance_your_round": "Mejora tu vuelta",
  "member_open_groups_to_join": "Grupos abiertos para unirse",
  "member_play_with_others": "Juega con otros",
  "member_no_open_groups_for_this_date_yet": "Aún no hay grupos abiertos para esta fecha.",
  "member__spots_available": "· Plazas disponibles:",
  "member_golf_booking": "Reserva de golf",
  "member_open_group_2_3": "Grupo abierto",
  "member_retry_price": "Volver a consultar precio",
  "member_includes_add_ons_selected": "Incluye los extras seleccionados",
  "member_booking_checkout": "Pago de la reserva",
  "member_go_to_dashboard": "Ir al inicio",
  "member_member_profile": "Perfil de socio",
  "member_mobile_bottom_navigation": "Navegación inferior móvil",
  "member_clearing": "Borrando",
  "member_loading_notifications": "Cargando notificaciones…",
  "member_no_notifications_yet": "Aún no hay notificaciones",
  "member_pending_confirmation": "Pendiente de confirmación",
  "member_select_a_room_type": "Seleccionar tipo de habitación",
  "member_confirm_booking": "Confirmar reserva",
  "member_member_account_club_billing": "Cuenta de socio / Facturación del club",
  "member_fitness_class": "Clase de fitness",
  "member_hotel_stay": "Estancia de hotel",
  "member_venue_service": "Lugar / Servicio",
  "member_you_may_cancel_this_dining_reservation_through_member_portal_cancellation": "Puedes cancelar esta reserva de restauración desde el portal de socios.",
  "member_close_all_club_news": "Cerrar todas las noticias del club",
  "member_close_entry_notification": "Cerrar notificación de acceso",
  "member_close_club_news": "Cerrar noticia del club",
  "member_close_all_upcoming_bookings": "Cerrar todas las próximas reservas",
  "member_past_experiences": "experiencias pasadas",
  "member_live_experiences": "experiencias actuales",
  "member_no_events_match_your_search_right_now": "No hay eventos que coincidan con tu búsqueda.",
  "member_no_past_events_just_yet": "Aún no hay eventos pasados.",
  "member_no_upcoming_events_right_now_please_check_back_soon": "No hay próximos eventos en este momento. Vuelve pronto.",
  "member_signature_event": "Evento especial",
  "member_an_exceptional_club_gathering": "Un encuentro excepcional en el club.",
  "member_club_venue": "Instalaciones del club",
  "member_guest_details": "Datos del invitado",
  "member_confirm_attendance": "Confirmar asistencia",
  "member_open_match_enabled": "Partido abierto activado",
  "member_none_selected": "Ninguno seleccionado",
  "member_book_court": "Reservar pista",
  "member_pending_join_requests": "Solicitudes de inscripción pendientes",
  "member_select_a_court": "Seleccionar pista",
  "member_selected_day": "Día seleccionado",
  "member_request_guest_pass": "Solicitar pase de invitado",
  "member_all_caught_up": "Todo al día",
  "member_unable_to_load_activities": "No se han podido cargar las actividades.",
  "member__count_upcoming_session": "{count} próxima sesión",
  "member__count_upcoming_sessions": "{count} próximas sesiones",
  "member_time_to_be_announced": "Hora por anunciar",
  "member_unable_to_update_booking": "No se ha podido actualizar la reserva.",
  "member_join_waitlist": "Unirse a la lista de espera",
  "member_join": "Unirse",
  "member__count_booked": "{count} reservas",
  "member_unable_to_clear_notifications": "No se han podido borrar las notificaciones",
  "member__count_new": "{count} nuevas",
  "member_unable_to_load_reciprocal_clubs": "No se han podido cargar los clubes recíprocos.",
  "member_please_select_a_visit_date_to_request_a_guest_pass": "Selecciona una fecha de visita para solicitar un pase de invitado.",
  "member_unable_to_submit_request": "No se ha podido enviar la solicitud.",
  "member_we_could_not_load_accommodations_right_now_please_try_again_shortly": "No se han podido cargar los alojamientos. Vuelve a intentarlo en unos instantes.",
  "member_please_choose_a_check_in_and_check_out_date": "Elige una fecha de llegada y de salida.",
  "member_check_out_must_be_after_check_in": "La salida debe ser posterior a la llegada.",
  "member_please_add_at_least_one_guest": "Añade al menos un huésped.",
  "member_please_choose_valid_dates_before_requesting_a_booking": "Elige fechas válidas antes de solicitar una reserva.",
  "member_we_were_unable_to_submit_your_request_please_try_again": "No se ha podido enviar tu solicitud. Vuelve a intentarlo.",
  "member_unable_to_load_event_details": "No se han podido cargar los detalles del evento.",
  "member_each_guest_needs_a_first_and_last_name": "Cada invitado debe tener nombre y apellidos.",
  "member_registration_failed": "No se ha podido completar la inscripción.",
  "member_location_coming_soon": "Ubicación próximamente",
  "member_availability_on_request": "Disponibilidad bajo consulta",
  "member_select_your_stay_dates": "Selecciona las fechas de tu estancia",
  "member_date_to_be_announced": "Fecha por anunciar",
  "member_you_re_in": "Tu asistencia está confirmada",
  "member__count_of_capacity_places_remaining": "{count} de {capacity} plazas disponibles",
  "member_guests_allowed_up_to_count": "Invitados permitidos: hasta {count}",
  "member_guests_allowed": "Invitados permitidos",
  "member_guests_not_permitted": "No se permiten invitados",
  "member_more_details_will_be_announced_shortly": "Se anunciarán más detalles próximamente.",
  "member_host_member": "Organizador · Socio",
  "member_live_price": "Precio actual",
  "member_add_name": "Añadir {name}",
  "member_member_on_file": "Socio registrado",
  "member_search_member_or_enter_guest_name": "Buscar socio o introducir nombre del invitado",
  "member_search_and_select_a_member": "Buscar y seleccionar un socio",
  "member_host": "Organizador",
  "member_tap_to_book": "Toca para reservar",
  "member_join_now": "Unirse ahora",
  "member_request_spot": "Solicitar plaza",
  "member_balance_loading": "Cargando saldo",
  "member_explore_events": "Explorar eventos",
  "member_racquet_open_match": "Raqueta · Partido abierto",
  "member_club_reservation": "Reserva del club",
  "member_this_booking_was_paid_online_please_contact_the_club_directly_if_you_wish_to_cancel_or_discuss_a_refund": "Esta reserva se pagó en línea. Contacta directamente con el club para cancelarla o consultar un reembolso.",
  "member_the_online_cancellation_period_has_passed_please_contact_the_club": "El plazo de cancelación en línea ha finalizado. Contacta con el club.",
  "member_online_cancellation_is_not_available_for_this_booking_please_contact_the_club": "Esta reserva no se puede cancelar en línea. Contacta con el club.",
  "member_unable_to_cancel_booking": "No se ha podido cancelar la reserva.",
  "member_your_tee_time_has_been_cancelled": "Tu salida de golf se ha cancelado.",
  "member_this_booking_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "Esta reserva está dentro del plazo de preaviso. Contacta con el club para cancelarla.",
  "member_please_contact_the_club_to_cancel_this_booking": "Contacta con el club para cancelar esta reserva.",
  "member_refund_outcome_no_refund": "Resultado del reembolso: sin reembolso",
  "member_cancellation_requires_manual_review": "La cancelación requiere una revisión manual.",
  "member_unable_to_cancel_booking_please_contact_the_club": "No se ha podido cancelar la reserva. Contacta con el club.",
  "member_your_racquet_booking_has_been_cancelled": "Tu reserva de pista se ha cancelado.",
  "member_your_spa_booking_has_been_cancelled": "Tu reserva de spa se ha cancelado.",
  "member_your_fitness_booking_has_been_cancelled": "Tu reserva de fitness se ha cancelado.",
  "member_this_stay_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "Esta estancia está dentro del plazo de preaviso. Contacta con el club para cancelarla.",
  "member_your_hotel_booking_has_been_cancelled": "Tu reserva de hotel se ha cancelado.",
  "member_cancellation_not_available_via_the_mobile_app": "La cancelación no está disponible desde la aplicación móvil.",
  "member_the_online_cancellation_window_has_closed_please_contact_the_club": "El plazo de cancelación en línea ha finalizado. Contacta con el club.",
  "member_this_reservation_can_no_longer_be_cancelled": "Esta reserva ya no se puede cancelar.",
  "member_this_reservation_could_not_be_found_please_contact_the_club": "No se ha encontrado esta reserva. Contacta con el club.",
  "member_cancellation_is_not_currently_available_please_contact_the_club": "La cancelación no está disponible en este momento. Contacta con el club.",
  "member_your_tee_time_is_confirmed": "Tu salida de golf está confirmada",
  "member_your_table_is_reserved": "Tu mesa está reservada",
  "member_your_stay_is_confirmed": "Tu estancia está confirmada",
  "member_your_open_match_is_live": "Tu partido abierto ya está disponible",
  "member_your_booking_is_confirmed": "Tu reserva está confirmada",
  "member_open_match_created": "Partido abierto creado",
  "member_your_match_is_now_visible_to_eligible_club_members_who_can_join_or_request_a_place_using_your_chosen_join_policy": "Tu partido ya está visible para los socios elegibles, que pueden unirse o solicitar una plaza según la política de inscripción que has elegido.",
  "member_loading_booking_details": "Cargando detalles de la reserva",
  "member_club_experience": "Experiencia del club",
  "member_players_count_of_capacity": "Jugadores · {count} de {capacity}",
  "member__count_places_open_type_policy": "{count} plazas libres · {type} · {policy}",
  "member__adults_adults_children_children_rooms_rooms": "{adults} adultos, {children} niños · {rooms} habitaciones",
  "member_stay_guests": "Huéspedes",
  "member_unable_to_load_course_details_right_now": "No se han podido cargar los detalles del campo.",
  "member_unable_to_load_this_tee_time_please_return_to_tee_times_and_try_again": "No se ha podido cargar esta salida. Vuelve a los horarios de salida e inténtalo de nuevo.",
  "member_at_least_one_player_is_required": "Se requiere al menos un jugador.",
  "member_please_select_holes_9_or_18": "Selecciona los hoyos (9 o 18).",
  "member_select_how_many_players_you_want_to_join_your_open_group": "Selecciona cuántos jugadores quieres que se unan a tu grupo abierto.",
  "member_open_group_spots_would_exceed_the_maximum_of_4_players": "Las plazas del grupo abierto superarían el máximo de 4 jugadores.",
  "member_this_tee_time_is_no_longer_available_please_reselect_a_tee_time": "Esta salida ya no está disponible. Selecciona otra.",
  "member_we_can_t_price_this_tee_time_right_now_please_try_another_time_or_contact_the_club": "No se puede calcular el precio de esta salida. Prueba otro horario o contacta con el club.",
  "member_we_couldn_t_calculate_your_booking_price_try_again_in_a_moment": "No se ha podido calcular el precio de tu reserva. Vuelve a intentarlo en unos instantes.",
  "member_unable_to_join_this_open_group_right_now": "No se ha podido completar la inscripción en este grupo abierto.",
  "member_we_could_not_complete_the_booking_please_check_your_details_and_try_again": "No se ha podido completar la reserva. Revisa los datos y vuelve a intentarlo.",
  "member_court_details_not_loaded": "No se han cargado los detalles de la pista",
  "member_start_time_missing": "Falta el horario de inicio",
  "member_please_resolve_player_details": "Completa los datos de los jugadores",
  "member_unable_to_load_court_details_right_now": "No se han podido cargar los detalles de la pista.",
  "member_please_select_a_valid_duration_for_this_court_and_time": "Selecciona una duración válida para esta pista y horario.",
  "member_invalid_sport_type": "Tipo de deporte no válido",
  "member_unable_to_join_open_match_right_now": "No se ha podido completar la inscripción en el partido abierto.",
  "member_spot_joined_payment_required_to_finalize_your_spot": "Plaza solicitada. Debes pagar para confirmar tu plaza.",
  "member_request_sent_you_will_be_notified_if_approved": "Solicitud enviada. Te avisaremos si se aprueba.",
  "member_unable_to_complete_payment_right_now": "No se ha podido completar el pago.",
  "member_charged_to_account": "Cargado a la cuenta",
  "member_unable_to_load_open_match_details_right_now": "No se han podido cargar los detalles del partido abierto.",
  "member_unable_to_update_join_request": "No se ha podido actualizar la solicitud de inscripción.",
  "member_request_approved": "Solicitud aprobada.",
  "member_request_rejected": "Solicitud rechazada.",
  "member_unable_to_load_this_course_right_now": "No se ha podido cargar este campo.",
  "member_unable_to_load_tee_times_right_now": "No se han podido cargar los horarios de salida.",
  "member_course_not_found_or_inactive": "El campo no se ha encontrado o está inactivo.",
  "member_you_already_joined_this_open_group": "Ya te has unido a este grupo abierto.",
  "member_this_open_group_is_full": "Este grupo abierto está completo.",
  "member_this_booking_is_no_longer_open_for_joins": "Esta reserva ya no admite inscripciones.",
  "member_this_booking_is_no_longer_available": "Esta reserva ya no está disponible.",
  "member_we_could_not_find_your_member_profile_for_this_club": "No se ha encontrado tu perfil de socio de este club.",
  "member_you_are_not_eligible_to_join_this_open_group": "No cumples los requisitos para unirte a este grupo abierto.",
  "member_member_name_required": "El nombre del socio es obligatorio",
  "member_guests_are_not_allowed_for_this_course_please_select_a_member": "No se permiten invitados en este campo. Selecciona un socio.",
  "member_select_a_member_from_the_list": "Selecciona un socio de la lista",
  "member_guest_full_name_email_and_phone_are_required": "El nombre completo, el correo y el teléfono del invitado son obligatorios",
  "member_we_could_not_complete_the_booking_please_try_again": "No se ha podido completar la reserva. Vuelve a intentarlo.",
  "member_primary_member_required": "El socio principal es obligatorio",
  "member_guests_are_not_allowed_on_this_court": "No se permiten invitados en esta pista",
  "member_guest_email_and_phone_are_required": "El correo y el teléfono del invitado son obligatorios",
  "member_available_tee_times": "Horarios de salida disponibles",
  "member_select_a_course": "Seleccionar campo",
  "member_back_to_courses": "Volver a campos",
  "member_choose_your_service": "Elige tu servicio",
  "member_book_a_class": "Reservar una clase",
  "member_that_court_has_just_been_taken_choose_another_available_time": "Esa pista acaba de reservarse. Elige otro horario disponible.",
  "member_payment_could_not_be_completed_your_court_has_not_been_booked": "No se ha podido completar el pago. Tu pista no se ha reservado.",
  "member_we_couldn_t_complete_your_booking_your_court_has_not_been_booked_or_charged": "No se ha podido completar la reserva. Tu pista no se ha reservado ni se ha realizado ningún cargo.",
  "member_we_couldn_t_complete_your_booking_please_try_again": "No se ha podido completar la reserva. Vuelve a intentarlo.",
  "member_unable_to_load_course_rates_right_now": "No se han podido cargar las tarifas del campo.",
  "member_unable_to_load_courses_right_now": "No se han podido cargar los campos.",
  "member_home": "Inicio",
  "member_dining": "Restauración",
  "member_profile": "Perfil",
  "member_member": "Socio",
  "member_dashboard": "Inicio",
  "member_club": "Club",
  "member_select_date": "Seleccionar fecha",
  "member__count_holes": "{count} hoyos",
  "member_player_caption": "Jugador",
  "member_players_caption": "Jugadores",
  "member_guests": "huéspedes",
  "member_joined": "Inscrito",
  "member_friendly": "Amistoso",
  "member_notification": "Notificación",
  "member_please_try_again": "Vuelve a intentarlo.",
  "member_notifications": "Notificaciones",
  "member_loading": "Cargando…",
  "member_refresh": "Actualizar",
  "member_clear_all": "Borrar todo",
  "member_activities": "Actividades",
  "member_academy": "Academia",
  "member_reciprocal_clubs": "Clubes recíprocos",
  "member_accommodations": "Alojamientos",
  "member_voting": "Votaciones",
  "member_review": "Revisa",
  "member_dates": "Fechas",
  "member_occupancy": "Ocupación",
  "member_room": "Habitación",
  "member_room_type": "Tipo de habitación",
  "member_select_dates": "Seleccionar fechas",
  "member_total": "Total",
  "member_from": "Desde",
  "member_view_details": "Ver detalles",
  "member_check_in": "Llegada",
  "member_check_out": "Salida",
  "member_rooms_caption": "Habitaciones",
  "member_close": "Cerrar",
  "member_room_details": "Detalles de la habitación",
  "member_cancel": "Cancelar",
  "member_no_upcoming_sessions": "No hay próximas sesiones",
  "member_activity": "Actividad",
  "member_full": "Completo",
  "member_unable_to_load_activity": "No se ha podido cargar la actividad.",
  "member_waitlisted": "En lista de espera",
  "member_available": "disponibles",
  "member_capacity_count": "Capacidad: {count}",
  "member_current_balance": "Saldo actual",
  "member_contact_front_desk": "Contactar con recepción",
  "member_golf_booking_caption": "Reserva de golf",
  "member_reservation": "Reserva",
  "member_open": "libres",
  "member_pdf_announcement": "Anuncio en PDF",
  "member_tee_time": "Salida de golf",
  "member_this_booking_has_already_been_cancelled": "Esta reserva ya se ha cancelado.",
  "member_golf_course": "Campo de golf",
  "member_booked": "reservados",
  "member_date": "Fecha",
  "member_holes_caption": "Hoyos",
  "member_add_ons": "Extras",
  "member_qty": "Cant.",
  "member_deadline": "Fecha límite:",
  "member_racquet_booking_caption": "Reserva de pista",
  "member_spa_booking": "Reserva de spa",
  "member_spa": "Spa",
  "member_service": "Servicio",
  "member_spa_service": "Servicio de spa",
  "member_fitness_class_caption": "Clase de fitness",
  "member_fitness": "Fitness",
  "member_hotel_rooms": "Hotel / Habitaciones",
  "member_accommodation": "Alojamiento",
  "member_dining_area": "Zona de restauración",
  "member_party_size": "Número de personas",
  "member_cost": "Coste",
  "member_status": "Estado",
  "member_good_morning": "Buenos días",
  "member_view_all": "Ver todo",
  "member_club_news": "Noticias del club",
  "member_retry": "Reintentar",
  "member_member_portal_entry_notification": "Notificación de acceso al portal de socios",
  "member_of": "de",
  "member_loading_reservation_details": "Cargando los detalles de la reserva…",
  "member_complimentary": "Gratuito",
  "member_unable_to_load_events": "No se han podido cargar los eventos.",
  "member_upcoming_caption": "Próximos",
  "member_past_events": "Eventos pasados",
  "member_event": "Evento",
  "member_reserved": "Reservado",
  "member_reserve": "Reservar",
  "member_add_guest": "Añadir invitado",
  "member_first_name": "Nombre",
  "member_last_name": "Apellidos",
  "member_email": "Correo electrónico",
  "member_phone": "Teléfono",
  "member_dietary": "Necesidades alimentarias",
  "member_notes": "Notas",
  "member_guest": "Invitado",
  "member_try_again": "Volver a intentar",
  "member_member_price": "Precio para socios",
  "member_continue": "Continuar",
  "member_classes": "Clases",
  "member_coach": "Entrenador",
  "member_golf": "Golf",
  "member_loading_tee_times": "Cargando horarios de salida…",
  "member_golf_tee_times": "Horarios de salida de golf",
  "member_select": "Seleccionar",
  "member_unable_to_load": "No se pudo cargar",
  "member_back": "Volver",
  "member_min": "min",
  "member_booking_type": "Tipo de reserva",
  "member_add_player": "Añadir jugador",
  "member_guest_name": "Nombre del invitado",
  "member_no_booking_durations_are_configured_for_this_court": "No hay duraciones de reserva configuradas para esta pista.",
  "member_racquet": "Deportes de raqueta",
  "member_duration": "Duración",
  "member_select_duration": "Seleccionar duración",
  "member_select_booking_type": "Seleccionar tipo de reserva",
  "member_remove": "Eliminar",
  "member_name": "Nombre",
  "member_guest_phone": "Teléfono del invitado",
  "member_confirmed": "confirmados",
  "member_pending_requests": "Solicitudes pendientes",
  "member_none": "Ninguno",
  "member_reject": "Rechazar",
  "member_approve": "Aprobar",
  "member_loading_courts": "Cargando pistas…",
  "member_show_less": "Ver menos",
  "member_availability": "Disponibilidad",
  "member_unavailable": "No disponible",
  "member_awaiting_approval": "Pendiente de aprobación",
  "member_checkout": "Pago",
  "member_grid": "Cuadrícula",
  "member_list": "Lista",
  "member_reciprocal_club_caption": "Club recíproco",
  "member_more": "más",
  "member__count_left": "{count} disponibles",
  "member_limited_availability": "Disponibilidad limitada",
  "member_creating_match": "Creando partido…",
  "member_reserving_court": "Reservando pista…",
  "member_manage_activities": "Gestionar actividades",
  "member_you_are_not_assigned_to_any_activities": "No tienes actividades asignadas.",
  "member_managed_activity": "Actividad a tu cargo",
  "member_manage_sessions": "Gestionar sesiones",
  "member_unable_to_load_sessions": "No se han podido cargar las sesiones.",
  "member_unable_to_update_session": "No se ha podido actualizar la sesión.",
  "member_you_do_not_have_access_to_this_activity": "No tienes acceso a esta actividad.",
  "member_viewing_roster": "Viendo participantes",
  "member_plan_your_next_experience_with_precision_and_ease": "Planifica tu próxima experiencia de forma sencilla y precisa.",
  "member_add_a_concierge_note": "Añadir una nota para conserjería",
  "member_decrease_adults_for_room_room": "Reducir adultos de la habitación {room}",
  "member_increase_adults_for_room_room": "Añadir adultos a la habitación {room}",
  "member_decrease_children_for_room_room": "Reducir niños de la habitación {room}",
  "member_increase_children_for_room_room": "Añadir niños a la habitación {room}",
  "member__holes_hole_pricing": "Tarifas de {holes} hoyos",
  "member_pay_amount": "Pagar {amount}",
  "member_guest_count": "Invitado n.º {count}",
  "member_member_count": "Socio n.º {count}",
  "member_calculating": "Calculando…",
  "member_choose_duration_for_name": "Elegir duración para {name}",
  "member_book_sport": "Reservar {sport}",
  "member_see_all_count": "Ver todos ({count})",
  "member_view_roster": "Ver participantes",
  "member_unable_to_load_roster": "No se han podido cargar los participantes.",
  "member_unable_to_create_session": "No se ha podido crear la sesión.",
  "member_sessions_caption": "Sesiones",
  "member_add_session": "Añadir sesión",
  "member_no_sessions_yet": "Aún no hay sesiones.",
  "member_cancelled": "Cancelado",
  "member_active": "Activo",
  "member_capacity": "Capacidad",
  "member_roster": "Participantes",
  "member_clear": "Borrar",
  "member_loading_roster": "Cargando participantes…",
  "member_no_bookings_yet": "Aún no hay reservas.",
  "member_member_caption": "Socio",
  "member_select_a_session_to_view_the_roster": "Selecciona una sesión para ver los participantes.",
  "member_start_time": "Hora de inicio",
  "member_select_time": "Seleccionar horario",
  "member_end_time": "Hora de fin",
  "member_optional": "Opcional",
  "member_processing_payment": "Procesando pago…",
  "member_remove_name": "Eliminar a {name}",
  "member_pending": "Pendiente",
  "member_paid": "Pagado",
  "member_completed": "Completadas",
  "member_no_show": "No presentado",
  "member_refunded": "Reembolsado",
  "member_failed": "Fallido",
  "member_expired": "Caducada",
  "member_held": "Plaza retenida",
  "member_status_unavailable": "Estado no disponible",
  "member_booking": "Reservando…",
  "member_requesting": "Solicitando…",
  "member_joining": "Uniéndose…",
  "member_guest_full_name": "Nombre completo del invitado",
  "member_book_tee_time": "Reservar salida",
  "member_booking_image_unavailable": "Imagen de reserva no disponible",
  "member_expected_refund_amount": "Reembolso previsto: {amount}",
  "member_expected_refund_amount_cancellation_fee_fee": "Reembolso previsto: {amount}; cargo de cancelación {fee}",
  "member__minutes_minutes_price": "{minutes} minutos{price}",
  "member_open_type_match_at_time_on_court_count_places_left": "Partido abierto {type} a las {time} en {court}, {count} plazas disponibles",
  "member_reciprocal_access": "Acceso recíproco",
  "member_booking_cancelled": "Reserva cancelada",
  "member_visit_request_approved": "Solicitud de visita aprobada",
  "member_scheduled_class": "Clase programada",
  "member_places_available_count": "Plazas disponibles: {count}",
  "member_primary_member": "Socio principal",
  "member_hotel_reservation": "Reserva de hotel",
  "member__sport_open_match": "{sport} · Partido abierto",
  "member_facility_unavailable": "Instalación no disponible",
  "member_book_tee_times": "Reservar salidas de golf",
  "member_reserve_courts": "Reservar pistas",
  "member_book_spa_services": "Reservar servicios de spa",
  "member_book_fitness_classes": "Reservar clases de fitness",
  "member_booking_coming_soon": "Reservas próximamente",
  "member_opening_secure_checkout": "Abriendo el pago seguro",
  "member_please_wait_while_we_prepare_your_payment": "Espera mientras preparamos tu pago.",
  "member_connecting_to_secure_checkout": "Conectando con el pago seguro…",
  "member_your_member_portal_tab_will_stay_open": "La pestaña del portal de socios permanecerá abierta.",
  "member_payment_received": "Pago recibido",
  "member_thank_you_your_payment_is_processing": "Gracias. Tu pago se está procesando.",
  "member_your_secure_checkout_has_completed_we_ll_update_your_account_as_soon_as_the_club_s_payment_confirmation_is_received": "El pago seguro ha finalizado. Actualizaremos tu cuenta cuando recibamos la confirmación del club.",
  "member_no_payment_was_taken": "No se ha realizado ningún cargo.",
  "member_you_can_return_to_your_account_and_start_secure_checkout_again_whenever_you_are_ready": "Puedes volver a tu cuenta e iniciar de nuevo el pago seguro cuando quieras.",
  "member_payment_declined": "Pago rechazado",
  "member_your_payment_could_not_be_completed": "No se ha podido completar tu pago.",
  "member_checkout_normally_shows_card_decline_messages_before_redirecting_this_page_is_here_if_the_club_sends_you_a_manual_declined_payment_link": "Normalmente, los avisos de rechazo de tarjeta aparecen durante el pago. Esta página se muestra si el club te envía un enlace manual de pago rechazado.",
  "member_secure_checkout_completed_in_stripe": "Pago seguro completado en Stripe.",
  "member_return_to_account": "Volver a la cuenta",
  "member_returning_you_to_your_booking": "Volviendo a tu reserva…",
  "member_your_booking_is_confirmed_you_can_close_this_checkout_tab_and_continue_in_your_original_booking_tab": "Tu reserva está confirmada. Puedes cerrar esta pestaña de pago y continuar en la pestaña original de la reserva.",
  "member_return_to_booking_confirmation": "Volver a la confirmación de reserva",
  "member_we_could_not_confirm_your_booking": "No se ha podido confirmar tu reserva",
  "member_payment_was_received_but_we_could_not_confirm_the_booking_automatically_please_contact_the_club": "Se ha recibido el pago, pero no se ha podido confirmar la reserva automáticamente. Contacta con el club.",
  "member_payment_was_received_but_the_booking_could_not_be_finalised_automatically_please_contact_the_club": "Se ha recibido el pago, pero no se ha podido finalizar la reserva automáticamente. Contacta con el club.",
  "member_still_confirming_your_payment_this_may_take_a_few_moments": "Seguimos confirmando tu pago. Puede tardar unos instantes.",
  "member_confirming_your_payment": "Confirmando tu pago…",
  "member_loading_secure_payment_link": "Cargando enlace de pago seguro…",
  "member_payment_link_unavailable": "Enlace de pago no disponible",
  "member_this_guest_payment_token_is_invalid_or_expired": "Este enlace de pago para invitados no es válido o ha caducado.",
  "member_privana_guest_payment": "Pago de invitado de Privana",
  "member_event_guest_ticket": "Entrada de invitado al evento",
  "member_date_time_tbc": "Fecha y hora por confirmar",
  "member_paid_online_thank_you": "Pagado en línea. Gracias.",
  "member_pay_securely_with_privana_pay": "Pagar de forma segura con Privana Pay",
  "member_your_payment_succeeded_we_are_finalising_your_booking_now": "Tu pago se ha realizado correctamente. Estamos finalizando tu reserva."
}
